import { ButtonsABSK, DatePickersABSK, InputABSK } from "../../../system/components";
import { AiOutlineClose } from "react-icons/ai";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useState } from "react";
import { firebaseApp } from "../../../system/firebase";

const ViewAdminActionAddEvent = ({ members, setModalAction }) => {
    const db = getFirestore(firebaseApp);
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('Conference');

    const [form, setForm] = useState({
        eventType: 'Conference',
        name: '',
        theme: '',
        startDate: '',
        endDate: '',
        venue: '',
        physicalFee: '',
        virtualFee: '',
        physicalFeeInclusives: '',
        virtualFeeInclusives: '',
        info: '',
        mpesaPaybill: '',
        mpesaAccount: '',
        bankName: '',
        bankAccount: '',
        keynoteSpeaker: '',
        topic: '',
        institution: '',
        department: '',
        deadline: '',
        email: '',
    });

    const [formWebinar, setFormWebinar] = useState({
        eventType: 'Webinar',
        title: '',
        date: '',
        time: '',
        speaker: '',
        speakerInfo: '',
        meetingLink: ''
    });

    const eventTypes = [
        { name: "Conference" },
        { name: "Webinar" },
    ];

    const addConference = async () => {
        if (!form.name || !form.venue || !form.physicalFee || !form.virtualFee) {
            alert('Please fill in the required fields (Name, Venue, Fees)');
            return;
        }
        setLoading(true);
        console.log('uploading form:', form);
        try {
            await addDoc(collection(db, 'ALL_EVENTS'), {
                ...form,
                eventType: 'Conference',
                createdAt: serverTimestamp(),
            });
            setLoading(false);
            setModalAction(false);
            console.log('Event created successfully');
        } catch (error) {
            setLoading(false);
            alert(error.message);
        }
    };

    const addWebinar = async () => {
        if (!formWebinar.title || !formWebinar.date || !formWebinar.speaker) {
            alert('Please fill in the required fields (Title, Date, Speaker)');
            return;
        }
        setLoading(true);
        try {
            await addDoc(collection(db, 'ALL_EVENTS'), {
                ...formWebinar,
                eventType: 'Webinar',
                createdAt: serverTimestamp(),
            });
            setLoading(false);
            setModalAction(false);
        } catch (error) {
            setLoading(false);
            alert(error.message);
        }
    };

    if (loading) {
        return <div className="modal-inner bg-white ver-flex centered">
            <div className="lds-spinner spinner-orange" style={{ margin: 0 }}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <h3>Creating Event</h3>
        </div>;
    }

    return <div className="modal-event">
        <div className="modal-close" onClick={() => setModalAction(false)}>
            <AiOutlineClose />
        </div>
        <h3 style={{ marginBottom: 15, marginTop: -30 }}>Add <span className="primary-color">New</span> Event</h3>
        <select className="up-down" value={type}
            onChange={(e) => {
                setType(e.target.value);
            }}>
            {eventTypes.map((item, key) => (
                <option value={item.name} key={key}>{item.name}</option>
            ))}
        </select>

        {type === 'Conference' ? <>
            <InputABSK.upDown placeholder={"Title"} style={{ width: 350 }} value={form.name} setValue={(e) => setForm({ ...form, name: e })} />
            <InputABSK.upDown placeholder={"Theme"} style={{ width: 350 }} value={form.theme} setValue={(e) => setForm({ ...form, theme: e })} />
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <DatePickersABSK.Primary text={"Start Date"} value={form.startDate} setValue={(e) => setForm({ ...form, startDate: e })} />
                <DatePickersABSK.Primary text={"End Date"} value={form.endDate} setValue={(e) => setForm({ ...form, endDate: e })} />
            </div>
            <InputABSK.upDown placeholder={"Venue"} style={{ width: 350 }} value={form.venue} setValue={(e) => setForm({ ...form, venue: e })} />
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <InputABSK.upDown placeholder={"Physical Fee (KES)"} value={form.physicalFee} setValue={(e) => setForm({ ...form, physicalFee: e })} />
                <InputABSK.upDown placeholder={"Virtual Fee (KES)"} value={form.virtualFee} setValue={(e) => setForm({ ...form, virtualFee: e })} />
            </div>
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <InputABSK.upDown placeholder={"Physical Fee Inclusives"} value={form.physicalFeeInclusives} setValue={(e) => setForm({ ...form, physicalFeeInclusives: e })} />
                <InputABSK.upDown placeholder={"Virtual Fee Inclusives"} value={form.virtualFeeInclusives} setValue={(e) => setForm({ ...form, virtualFeeInclusives: e })} />
            </div>
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <InputABSK.upDown placeholder={"Mpesa Paybill"} value={form.mpesaPaybill} setValue={(e) => setForm({ ...form, mpesaPaybill: e })} />
                <InputABSK.upDown placeholder={"Mpesa Account"} value={form.mpesaAccount} setValue={(e) => setForm({ ...form, mpesaAccount: e })} />
            </div>
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <InputABSK.upDown placeholder={"Bank Name"} value={form.bankName} setValue={(e) => setForm({ ...form, bankName: e })} />
                <InputABSK.upDown placeholder={"Bank Account"} value={form.bankAccount} setValue={(e) => setForm({ ...form, bankAccount: e })} />
            </div>
            <InputABSK.upDown placeholder={"Keynote Speaker"} style={{ width: 350 }} value={form.keynoteSpeaker} setValue={(e) => setForm({ ...form, keynoteSpeaker: e })} />
            <InputABSK.upDown placeholder={"Topic"} style={{ width: 350 }} value={form.topic} setValue={(e) => setForm({ ...form, topic: e })} />
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <InputABSK.upDown placeholder={"Institution"} value={form.institution} setValue={(e) => setForm({ ...form, institution: e })} />
                <InputABSK.upDown placeholder={"Department"} value={form.department} setValue={(e) => setForm({ ...form, department: e })} />
            </div>
            <div className='hor-flex noPadding' style={{ width: 350, columnGap: 15 }}>
                <InputABSK.upDown placeholder={"Deadline"} value={form.deadline} setValue={(e) => setForm({ ...form, deadline: e })} />
                <InputABSK.upDown placeholder={"Contact Email"} value={form.email} setValue={(e) => setForm({ ...form, email: e })} />
            </div>
            <InputABSK.upDown placeholder={"More Information"} style={{ width: 350 }} value={form.info} setValue={(e) => setForm({ ...form, info: e })} />
            <ButtonsABSK.primary onClick={addConference} text={"Create Event"} style={{ width: 350, height: 50, fontSize: 15, marginTop: 0 }} />
        </> : <>
            <InputABSK.upDown placeholder={"Title"} style={{ width: 350 }} value={formWebinar.name} setValue={(e) => setFormWebinar({ ...formWebinar, title: e })} />
            <DatePickersABSK.Primary text={"Date"} style={{ width: 350 }} value={formWebinar.date} setValue={(e) => setFormWebinar({ ...formWebinar, date: e })} />
            {/* <InputABSK.upDown placeholder={"Time"} style={{ width: 350 }} value={formWebinar.time} setValue={(e) => setFormWebinar({ ...formWebinar, time: e })} /> */}
            <InputABSK.upDown placeholder={"Speaker"} style={{ width: 350 }} value={formWebinar.speaker} setValue={(e) => setFormWebinar({ ...formWebinar, speaker: e })} />
            <InputABSK.upDown placeholder={"Speaker Info"} style={{ width: 350 }} value={formWebinar.speakerInfo} setValue={(e) => setFormWebinar({ ...formWebinar, speakerInfo: e })} />
            <InputABSK.upDown placeholder={"Meeting Link"} style={{ width: 350 }} value={formWebinar.meetingLink} setValue={(e) => setFormWebinar({ ...formWebinar, meetingLink: e })} />
            <ButtonsABSK.primary onClick={addWebinar} text={"Create Event"} style={{ width: 350, height: 50, fontSize: 15, marginTop: 0 }} />
        </>}
    </div>;
};

export default ViewAdminActionAddEvent;